
import DataTable from 'react-data-table-component';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useMemo, useState, useRef } from 'react';
import {  fetchData, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';



import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Tr } from '../../../_metronic/i18n/Tr';

function TourTypePage() {
let t= Tr()

  const [showPopup, setShowPopup] = useState(false)
  const [tourtypeList,setTourtypeList]=useState([])
  const [orgtourtypeList,setOrgTourtypeList]=useState([])
  const [tourtypeId,setTourtypeId]=useState(0)
  const [searchTerm,setSearchTerm]=useState("")
  const [focus,setFocus]=useState(0)
  const [categoryList,setCategoryList]=useState([])

  const Popup = (props:any) => {
  // add / edit facility states
  const [tourtypeId,setTourtypeId]=useState(props.tourtypeid);
  const [enName,setEnName]=useState("")
  const [ruName,setRuName]=useState("")
  const [uzName,setUzName]=useState("")
  const [categoryId,setCategoryId]=useState(null)
  const [error,setError]=useState(Object)
  const [imageUrl,setImageUrl]=useState("")
  const [addloader,setaddLoader]=useState(false)
  const [disable,setDisable]=useState(false)

  

  const savetourtype=async()=>{
    setDisable(true)

    
    var param:any={
      enName:enName,
      ruName:ruName,
      uzName:uzName
    }
    if(props.tourtypeid!="" && props.tourtypeid!=null && props.tourtypeid>0 )
    {
      param['tourtypeId']=props.tourtypeid
    }
    
    var res=await fetchData("admin/addedittourtype",param)
    if(res.status=="200")
    {
      if(props.tourtypeid!=="" && props.tourtypeid!==null && props.tourtypeid>0 )
      {
        toastsuccessmsg("Tour Type Updated Successfully")
      }
      else
      {
        toastsuccessmsg("Tour Type Added Successfully")
      }
      setDisable(false)
      props.onHide()
      tourtypelistapicall()
    }
    else
    {
      setaddLoader(false)
      setDisable(false)
      toasterrormsg(res.message)
    }
  }
  const validate=()=>{
    var errotmp:any={}
    var err=0
    if(enName.trim()=="" || enName.trim()==null || enName.trim()==undefined)
    {
      errotmp['enNameError']="Tour Type English Name Required"
      err=1
    }
    else if(enName.trim().length>50)
    {
      errotmp['enNameError']="Tour Type English Name Is To Large"
      err=1
    }
    else if(!enName.match(/^[A-Za-z\s&]+$/))
    {
      errotmp['enNameError']="Enter Valid Tour Type English Name"
      err=1
    }
    if(ruName.trim()=="" || ruName.trim()==null || ruName.trim()==undefined)
    {
      errotmp['ruNameError']="Tour Type Russian Name Required"
      err=1
    }
    else if(ruName.trim().length>50)
    {
      errotmp['ruNameError']="Tour Type Russian Name Is To Large"
      err=1
    }
    if(uzName.trim()=="" || uzName.trim()==null || uzName.trim()==undefined)
    {
      errotmp['uzNameError']="Tour Type Uzbek Name Required"
      err=1
    }
    else if(uzName.trim().length>50)
    {
      errotmp['uzNameError']="Tour Type Uzbek Name Is To Large"
      err=1
    }
    
    setError(errotmp)
    if(err==0)
    {
      savetourtype()
    }
  }
  const tourtypedetail=async()=>{
    setaddLoader(true)
    var param={
      tourtypeId:props.tourtypeid
    }
    var res=await fetchData("admin/tourtypedetail",param)
    if(res.status=="200")
    {
      var data=res.data[0]

      setImageUrl(data.image)
      setEnName(data.en_name)
      setRuName(data.ru_name)
      setUzName(data.uz_name)
      var tmp=categoryList.filter((item:any)=>item.value==data.categoryId);
      setCategoryId(tmp.length>0?tmp[0]:null)
          
      setaddLoader(false)
    }
    else
    {
      setaddLoader(false)
      toasterrormsg(res.message)
    }

  }
  
  
  useEffect(()=>{
  
    if(props.tourtypeid>0)
    {
      
      tourtypedetail()
    
    }

    
  },[])
  

  // add / edit facility state end
    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-hcenter"
        dialogClassName='maxwidth1000px'
        centered
        backdrop="static" keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10' >
            <h4 className='fw-bold'>{tourtypeId!=="" && tourtypeId!==null && tourtypeId>0?"Edit":"Add"} Tour Type</h4>
          </div>

        </Modal.Header>
        <Modal.Body>
              
            <div className="stepper stepper-links d-flex flex-column" id="kt_create_account_stepper" data-kt-stepper="true">
                

                <div className="mx-auto row w-100 py-10" id="kt_create_account_form">
               
                  <div className='col-xl-4 col-lg-4'>
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">English Name</label>
                    <input type="text" name="tourtypename" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="English Name" value={enName} onChange={(e:any)=>setEnName(e.target.value)}></input>
                    <label className='text-danger'>{error.enNameError || ""}</label>
                  </div>
                  <div className='col-xl-4 col-lg-4'>
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">Russian Name</label>
                    <input type="text" name="tourtypename" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Russian Name" value={ruName} onChange={(e:any)=>setRuName(e.target.value)}></input>
                    <label className='text-danger'>{error.ruNameError || ""}</label>
                  </div>
                  <div className='col-xl-4 col-lg-4'>
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">Uzbek Name</label>
                    <input type="text" name="tourtypename" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Uzbek Name" value={uzName} onChange={(e:any)=>setUzName(e.target.value)}></input>
                    <label className='text-danger'>{error.uzNameError || ""}</label>
                  </div>
                  
                  
                  {/* action button start */}
                  <div className={`d-flex pt-15 justify-content-center`}>
                    <button type="button" className={`btn btn-lg btn-light-success me-3`}  onClick={props.onHide}>
                      Cancel
                    </button>
                    
                    

                    <button type="button" disabled={disable} className={`btn btn-lg btn-success monthBtn me-3`} onClick={()=>validate()}>
              

                          {!disable && 'Save'}
                          {disable && (
                            <span className='indicator-progress' style={{display: 'block'}}>
                              Please wait...{' '}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                    </button>
                  </div>
                  {/* action button end */}
                    
                </div>
                    
            </div>
        </Modal.Body>
       
      </Modal>
    )
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [
      
    
      {
        name: 'English Name',
        cell: (row: any) => <div className="my-3">
            
                <div className="fw-bold fs-5">
                    {row.en_name}
                </div>


        </div>,
        sortable: true,
        filter: true,
        selector:(row:any)=>String(row.en_name),
      },
      {
        name: 'Russian Name',
        cell: (row: any) => <div className="my-3">
            
                <div className="fw-bold fs-5">
                    {row.ru_name}
                </div>


        </div>,
        sortable: true,
        selector:(row:any)=>String(row.ru_name),
        filter: true,
      },
      {
        name: 'Uzbek Name',
        cell: (row: any) => <div className="my-3">
            
                <div className="fw-bold fs-5">
                    {row.uz_name}
                </div>


        </div>,
        sortable: true,
        selector:(row:any)=>String(row.uz_name),
        filter: true,
      },
      
      {
        name: 'Action',
        cell: (row: any) => (
          

          <>
            <button className="btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light" title='Edit' onClick={()=>{setShowPopup(true);setTourtypeId(row.tourtypeId)}}>
              <FontAwesomeIcon icon={faEdit} />
            </button>
            
            <button className="btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2" title='delete' onClick={()=>deletetourtype(row.tourtypeId,row.en_name)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </>
           
          
        ),
        width:"140px"
      },
    ],
    [t]
  )

  const deletetourtype = async (tourtypeId: any,tourtypeName:any) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You Want To Delete '+tourtypeName+' Tourtype!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
       
        try {
          var param:any={
            tourtypeId:String(tourtypeId)
          }
          
          const response = await fetchData('admin/deletetourtype', param);
  
          if (response.status == '200') {
            toastsuccessmsg(response.message);
            tourtypelistapicall()
          } else {
            toasterrormsg(response.message);
            
          }
        } catch (error) {
         
          toasterrormsg('An error occurred while processing your request.');
        }
      } 
    });
  };

  // call tourtype list api 
  const tourtypelistapicall=async()=>{
    
    
    var param:any={}
    


    var response:any=await fetchData("admin/tourtypelist",param)   
   
    if(response.status=="200")
    {
      
      setTourtypeList(response.data)
      setOrgTourtypeList(response.data)
                
    }
    else
    {
      
      
        toasterrormsg(response.message)
    }
  }

    // call category list api 
    const categorylistapicall=async()=>{
    
    
      var param:any={}

      var response:any=await fetchData("admin/categorylist",param)   
     
      if(response.status=="200")
      {
        var tmp:any=response.data.map((item:any)=>{return{value:item.categoryId,label:item.en_name}})
        setCategoryList(tmp)
        
                  
      }
      else
      {
        
        
          toasterrormsg(response.message)
      }
    }

  useEffect(()=>{
    document.title = 'Insayr | Tour Type' 
    tourtypelistapicall()
    categorylistapicall()
  },[])

  const CustomHeader=(props:any)=>{
    const inputRef:any = useRef(null);
   

    // Define the onchange event handler
    const handleChange = async(e:any) => {      
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e,1)
      // inputRef.current.focus();
    };
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus();
      }
    }, [props.isfoc]); 
    return(
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search Tour Type'
            value={props.search}
            onChange={(e:any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
    
          <button
            type='button'
            className='btn btn-success monthBtn'
            onClick={()=>setShowPopup(true)}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Add Tour Type
          </button>
          {/* end::Add Department */}
        </div>
      </div>
    )
  }

  //search function
  const tourtypesearch=async(text:any,isfoc:any)=>{
   
    setSearchTerm(text)
    setFocus(isfoc)
   
    if(text=="" || text==null || text==undefined)
    {
      setTourtypeList(orgtourtypeList)
    }
    else
    {
   
      var tmp:any=orgtourtypeList.filter((item:any)=>(item.en_name!=null && item.en_name!="" && item.en_name.toLowerCase() == text.toLowerCase())
      || (item.en_name!=null && item.en_name!="" && item.en_name.toLowerCase().includes(text.toLowerCase()))
      || (item.ru_name!=null && item.ru_name!="" && item.ru_name == text)
      || (item.ru_name!=null && item.ru_name!="" && item.ru_name.includes(text))
      || (item.uz_name!=null && item.uz_name!="" && item.uz_name == text)
      || (item.uz_name!=null && item.uz_name!="" && item.uz_name.includes(text)))
      setTourtypeList(tmp)
    }
  }

  return (<>
    <ToastContainer />
      <div className="container-fluid">
  
        
        <div className="row mt-5">
          <div className="col-12">
            {orgtourtypeList.length>0?
            <>
            
            <DataTable
                columns={column}
                data={tourtypeList}
                pagination
                paginationServer={false}
                subHeader={true}
                subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} customSearch={tourtypesearch} />}
             
            />
 
  
      
          </>
            :
            <>
              <div className="text-center px-4">
                <div className='d-flex justify-content-center align-items-center flex-column my-10 py-20'>
                  <h2 className="fs-2x fw-bold mb-10">Welcome To Tour Type</h2>
                </div>
                <p className="text-gray-400 fs-4 fw-semibold mb-10">There are no Tour Type</p>
                <Link to="#" className="btn btn-success monthBtn" onClick={()=>setShowPopup(true)}>Add Tour Type</Link>
                <br/>
              </div>
              <div className="d-flex justify-content-center">
                <img className="mw-100 mh-300px" alt="" src={toAbsoluteUrl("/media/illustrations/sketchy-1/2.png")} />
              </div>
            </>
            }
  
          </div>
        </div>
        
  
        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {setShowPopup(false);setTourtypeId(0);}}
            tourtypeid={tourtypeId}
          />
        )}
        
      </div>
  
  
      </>
    );
}

export default TourTypePage;



	